<script>
  import { onMount } from "svelte";
  import Papa from "papaparse";
  import { saveAs } from "file-saver";
  import {
    decorateMember,
    localeOrderBy,
    slice,
    loadPersisted,
    savePersisted,
  } from "../../mjnUtils";
  import Pagination from "./pagination/Pagination.svelte";

  let { http, toastr, search } = $props();

  const memberIcons = {
    0: "far fa-user",
    1: "fas fa-user",
    2: "fas fa-house-user",
    3: "fas fa-user-tie",
    4: "fas fa-user-alt-slash",
  };

  let members = $state([]);
  let counts = $state([0, 0, 0, 0, 0]);
  let memberButton = $state(loadPersisted("main", "memberButton", 2));
  let searchText = $state("");
  let sortType = $state(loadPersisted("main", "sortType", "nazwisko"));
  let sortReverse = $state(loadPersisted("main", "sortReverse", true));
  let currentPage = $state(1);
  const itemsPerPage = 11;

  $effect(() => {
    savePersisted("main", "memberButton", memberButton);
    savePersisted("main", "sortType", sortType);
    savePersisted("main", "sortReverse", sortReverse);
  });

  onMount(() => {
    http.get("/api/czlonek.php").then(
      (response) => {
        if (response.data.status == 200) {
          const loadedCounts = [0, 0, 0, 0, 0];
          for (const member of response.data.records) {
            decorateMember(member);
            loadedCounts[member.typ]++;
          }
          members = response.data.records;
          counts = loadedCounts;
        } else {
          toastr.error("Błąd: " + response.data.message);
        }
      },
      () => {
        toastr.error("Błąd połączenia");
      },
    );
  });

  function memberSelect(memberButtonValue) {
    return function (member) {
      switch (memberButtonValue) {
        case 1:
          return member.typ == 0;
        case 2:
          return [1, 2, 3].indexOf(member.typ) > -1;
        case 3:
          return member.typ == 4;
      }
    };
  }

  function exportCsv() {
    const output = Papa.unparse(filteredMembers, {
      columns: [
        "imie",
        "nazwisko",
        "data_urodzenia",
        "dzielnica",
        "kod_pocztowy",
        "email",
        "email_mjn",
        "email_slack",
        "nrtel",
        "data_uchwaly",
        "nr_uchwaly",
        "data_odejscia",
        "typ_text",
      ],
    });
    const blob = new Blob([output], { type: "text/plain;charset=utf-8" });
    saveAs(blob, "czlonkowie.csv");
  }

  let byType = $derived(members.filter(memberSelect(memberButton)));
  let filteredMembers = $derived(search(byType, searchText));
  let sortedMembers = $derived(localeOrderBy(filteredMembers, sortType, sortReverse));
  let totalItems = $derived(filteredMembers.length);
  let numPages = $derived(Math.max(1, Math.ceil(totalItems / itemsPerPage)));
  let pagedMembers = $derived(slice(sortedMembers, itemsPerPage, currentPage));

  $effect(() => {
    searchText;
    memberButton;
    currentPage = 1;
  });

  function setSort(field) {
    if (sortType === field) {
      sortReverse = !sortReverse;
    } else {
      sortType = field;
      sortReverse = false;
    }
  }

  function emailOf(member) {
    return member.email_mjn ?? member.email;
  }
</script>

<div id="header">
    <h3><i class="fas fa-user-friends"></i>&nbsp;&nbsp;Ludzie w Stowarzyszeniu
    <div class="btn-toolbar pull-right">
        <a class="btn btn-primary btn-sm pull-right" href="/member-edit/-1" title="Przejście do karty edycji, na której wpisujemy dane nowego Członka Stowarzyszenia."><i class="fas fa-plus" aria-hidden="true"></i>
            <span class="hidden-xs">&nbsp;Dodaj nową osobę...</span></a>
        <button class="btn btn-primary btn-sm pull-right" onclick={exportCsv} title="Eksport do pliku tekstowego, który można otworzyć Excelem. Eksportowane są tylko wpisy widoczne na liście poniżej (można je wybrać za pomocą pola wyszukiwania)."><i class="fas fa-share-square" aria-hidden="true"></i>
            <span class="hidden-xs">&nbsp;Eksportuj do csv</span></button>
        <div class="btn-group">
            {#if counts[0] !== 0}
            <button class="btn btn-sm btn-default" class:active={memberButton===1} onclick={() => memberButton = 1} title="Pokazuj tylko Kandydatów na Członka Stowarzyszenia"><i class="far fa-user" aria-hidden="true"></i>
                <span class="hidden-xs">&nbsp;Kandydaci</span></button>
            {/if}
            <button class="btn btn-sm btn-default" class:active={memberButton===2} onclick={() => memberButton = 2} title="Pokazuj tylko Członków Stowarzyszenia"><i class="fas fa-user" aria-hidden="true"></i>
                <span class="hidden-xs">&nbsp;Członkowie</span></button>
            <button class="btn btn-sm btn-default" class:active={memberButton===3} onclick={() => memberButton = 3} title="Pokazuj tylko byłych Członków Stowarzyszenia"><i class="fas fa-user-alt-slash" aria-hidden="true"></i>
                <span class="hidden-xs">&nbspByli członkowie</span></button>
        </div>
    </div>
    </h3>
    <div class="clearfix"></div>
    <div class="text-left"><small>
    <i class="fa fa-random" aria-hidden="true"></i>
    W tej chwili mamy {counts[1]+counts[2]+counts[3]} członkiń/ów ({counts[1]} zwyczajnych, {counts[2]} wspierających i {counts[3]} honorowych).
    W bazie jest równiez {counts[0]} kandydatów i {counts[4]} byłych członków.
    {#if searchText != ""}Poniżej widać {filteredMembers.length} przefiltrowanych.{/if}
    </small><p></p></div>

    <form class="form">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-addon"><i class="fa fa-search"></i></div>
            <input type="text" class="form-control input-sm" placeholder="Wyszukaj nazwisko, dzielnicę, itd." bind:value={searchText}>
          </div>
        </div>
    </form>
</div>

<div>
<table class="table table-condensed table-hover table-striped">

    <thead class="thead-default">
      <tr>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("nazwisko"); }}>
          Imię i nazwisko
          {#if sortType == "nazwisko" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "nazwisko" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs hidden-sm">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("typ"); }}>
          Członkostwo
          {#if sortType == "typ" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "typ" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs hidden-sm">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("email"); }}>
          Email
          {#if sortType == "email" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "email" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs hidden-sm">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("kod_pocztowy"); }}>
          Kod pocztowy
          {#if sortType == "kod_pocztowy" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "kod_pocztowy" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs hidden-sm">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("nrtel"); }}>
          Nr telefonu
          {#if sortType == "nrtel" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "nrtel" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th class="hidden-xs hidden-sm">
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("dzielnica"); }}>
          Dzielnica
          {#if sortType == "dzielnica" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "dzielnica" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          <a href="#" onclick={(e) => { e.preventDefault(); setSort("data_uchwaly"); }}>
          Data przyjęcia<span class="hidden-xs hidden-sm"> (nr uchwały)</span>
          {#if sortType == "data_uchwaly" && !sortReverse}<span class="fa fa-caret-down"></span>{/if}
          {#if sortType == "data_uchwaly" && sortReverse}<span class="fa fa-caret-up"></span>{/if}
          </a>
        </th>
        <th>
          Operacje
        </th>
      </tr>
    </thead>

    <tbody>
      {#each pagedMembers as czlonek (czlonek.idcz)}
      <tr>
        <td>
            <i class="{memberIcons[czlonek.typ]} fa-lg fa-fw" aria-hidden="true" style="margin: 6px 0px 8px 0px;"></i>&nbsp;&nbsp;
            <a href={"/member-detail/" + czlonek.idcz}>
                {czlonek.imie} {czlonek.nazwisko}
            </a>
            <div class="visible-xs visible-sm small text-muted">
                <span style="white-space: nowrap;"><i class="fas fa-phone fa-fw" aria-hidden="true"></i>{czlonek.nrtel}</span>
                <span style="white-space: nowrap;"><i class="fas fa-at fa-fw" aria-hidden="true"></i>{emailOf(czlonek)}</span>
            </div>
            <div class="visible-xs visible-sm small text-muted">
                <span style="white-space: nowrap;"><i class="fas fa-puzzle-piece fa-fw" aria-hidden="true"></i>{czlonek.dzielnica}</span>
            </div>
        </td>
        <td class="hidden-xs hidden-sm">
        {czlonek.typ_text}
        </td>
        <td class="hidden-xs hidden-sm">
        {emailOf(czlonek)}
        </td>
        <td class="hidden-xs hidden-sm">
          {czlonek.kod_pocztowy}
        </td>
        <td class="hidden-xs hidden-sm">
        {czlonek.nrtel}
        </td>
        <td class="hidden-xs hidden-sm">
        {czlonek.dzielnica}
        </td>
        <td>
        {czlonek.data_uchwaly} ({czlonek.nr_uchwaly})
        </td>
        <td>
            <div>
                <a href={"/member-detail/" + czlonek.idcz} title="Podgląd danych"><i class="fas fa-eye fa-lg fa-fw"></i></a>
                <a href={"/member-edit/" + czlonek.idcz} title="Edycja"><i class="fas fa-pen-square fa-lg fa-fw"></i></a>
            </div>
        </td>
      </tr>
      {/each}
    </tbody>

</table>
</div>

<div id="footer">
    <Pagination {currentPage} {numPages} onPageChange={(page) => currentPage = page}/>
</div>
